import React from 'react';
import PropTypes from 'prop-types';

export const NextArrow = props => {
	const { classLabel, onClick, visible } = props;

	return <button type="button" className={'slick-arrow slick-next' + (visible ? ' on ' : ' off ') + classLabel} onClick={onClick} aria-label="Next slide" />;
};

export const PrevArrow = props => {
	const { classLabel, onClick, visible } = props;

	return <button type="button" className={'slick-arrow slick-prev' + (visible ? ' on ' : ' off ') + classLabel} onClick={onClick} aria-label="Previous slide" />;
};

PrevArrow.propTypes = {
	classLabel: PropTypes.string,
	visible: PropTypes.bool,
	onClick: PropTypes.func
};

NextArrow.propTypes = {
	classLabel: PropTypes.string,
	visible: PropTypes.bool,
	onClick: PropTypes.func
};
